import { useCallback, useEffect, useState } from 'react';

/**
 * Modo claro y oscuro — el MISMO mecanismo del sistema interno.
 *
 * Se copia de frontend/src/utils/theme.js a propósito, hasta el nombre del atributo
 * (`data-theme`) y los valores (`dark` / `light`). Son dos aplicaciones que se compilan aparte,
 * así que el código no se puede compartir; lo que sí se comparte es la convención. Si aquí se
 * inventara otra —`data-tema`, `oscuro`— los estilos copiados del sistema dejarían de aplicar y
 * habría que traducirlos uno por uno cada vez que allá cambie algo.
 *
 * La llave de guardado sí es propia (`portal-wf-theme`): es la preferencia de una persona en su
 * navegador, y un cliente y un empleado no tienen por qué compartirla.
 *
 * Arranca por lo que tenga puesto el sistema operativo y respeta la elección si la cambia. Se
 * guarda por aparato, no en la cuenta: la misma persona entra desde la oficina y desde el
 * teléfono, y cada uno tiene su luz.
 */
const LLAVE = 'portal-wf-theme';

const temaInicial = () => {
  try {
    const guardado = localStorage.getItem(LLAVE);
    if (guardado === 'dark' || guardado === 'light') return guardado;
  } catch {
    // El tema sigue funcionando aunque el navegador bloquee el almacenamiento.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export function useTema() {
  const [tema, setTema] = useState(temaInicial);

  useEffect(() => {
    document.documentElement.dataset.theme = tema;
    // colorScheme le dice al navegador cómo pintar lo suyo: barras de desplazamiento, el
    // interior de un <select>, el calendario de un campo de fecha. Sin esto quedan blancos
    // sobre el fondo oscuro.
    document.documentElement.style.colorScheme = tema;
    try { localStorage.setItem(LLAVE, tema); } catch { /* es solo una preferencia */ }
  }, [tema]);

  const alternar = useCallback(() => {
    setTema((actual) => (actual === 'dark' ? 'light' : 'dark'));
  }, []);

  return { tema, alternar };
}
